import DisciplinePackagesApp from "./DisciplinePackagesApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(DisciplinePackagesApp);
